















































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import Subtitle from '@/components/molecules/Typography/Subtitle.vue';
import Container from '@/components/atoms/Grid/Container.vue';
import Description from '@/components/molecules/Typography/Description.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import { TicketType } from '@/api/enums/ticket-type.enum';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import { TicketTypeDescription } from '@/api/messages/ticket-request.message';
import TicketRequestDeleteCustomer from './TicketRequestTypes/TicketRequestDeleteCustomer.vue';

@Component({
  components: {
    Description,
    Container,
    Subtitle,
    TextInput,
    CustomSelect,
    FormLabel
  }
})
export default class NewTicketRequest extends Vue {
  @Prop() readonly data!: any;

  loading = false;

  selectedTicketTypeModel: any = [];
  ticketTypeActive?: TicketType;
  ticketComponent: any = null;

  ticketTypeComponenets = {
    [TicketType.DeleteCustomer]: TicketRequestDeleteCustomer
  };

  created() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption(
        TicketType.DeleteCustomer,
        TicketTypeDescription[TicketType.DeleteCustomer]
      )
    ]);

    this.selectedTicketTypeModel = new CustomSelectModel(
      [actionGroup],
      `Select ticket type`,
      false,
      false,
      false,
      true
    );
  }

  updateForm(selectedTicketTypes: CustomSelectOption[]) {
    const [selectedTicketType] = selectedTicketTypes;

    const ticketType = selectedTicketType.uuid as TicketType;

    this.ticketTypeActive = ticketType;
    this.ticketComponent = this.ticketTypeComponenets[ticketType];
  }
}
